// Component for displaying Oma's opening question

import { motion } from 'framer-motion';

interface OpeningQuestionProps {
  question: string;
  isLoading?: boolean;
}

export function OpeningQuestion({ question, isLoading = false }: OpeningQuestionProps) {
  if (isLoading) {
    return (
      <div style={{
        maxWidth: '42rem',
        margin: '0 auto var(--space-4xl)',
        padding: '0 var(--space-xl)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px'
      }}>
        <div style={{
          width: '2px',
          height: '2px',
          backgroundColor: 'var(--color-text-secondary)',
          borderRadius: '50%',
          animation: 'pulse 1.5s ease-in-out infinite'
        }} />
      </div>
    );
  }

  const paragraphs = question.split('\n\n').filter(p => p.trim());

  return (
    <motion.div
      style={{
        maxWidth: '42rem',
        margin: '0 auto var(--space-4xl)',
        padding: '0 var(--space-xl)'
      }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {paragraphs.map((paragraph, index) => (
        <motion.p
          key={index}
          className="oma-voice"
          style={{ marginBottom: 'var(--space-xl)' }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ 
            duration: 0.4, 
            delay: index * 0.2,
            ease: "easeOut"
          }}
        >
          {paragraph}
        </motion.p>
      ))}
    </motion.div>
  );
}
